import React from "react";
import { Flame, ChefHat, Droplets, Zap, Leaf, Sun, Layers, Wind, Package, Coffee } from "lucide-react";

const DISH_TYPES = [
  { key: "Curry",        icon: Flame,   color: "#E07A5F", desc: "Warm & spiced" },
  { key: "Rice Pot",     icon: ChefHat, color: "#81B29A", desc: "Khichdi style" },
  { key: "Soup",         icon: Coffee,  color: "#7EB3D4", desc: "Light & brothy" },
  { key: "Stir-fry",    icon: Zap,     color: "#F2CC8F", desc: "Quick sauté" },
  { key: "Dal",          icon: Leaf,    color: "#81B29A", desc: "Lentil-based" },
  { key: "Porridge",     icon: Sun,     color: "#C4A882", desc: "Soft & warming" },
  { key: "Wrap / Bowl",  icon: Layers,  color: "#9AA5B1", desc: "Assembled dish" },
  { key: "Stew",         icon: Wind,    color: "#7EB3D4", desc: "Slow-cooked" },
  { key: "Salad (Warm)", icon: Package, color: "#81B29A", desc: "Warm & tossed" },
  { key: "Flatbread",    icon: Droplets,color: "#C4A882", desc: "Stuffed / topped" },
];

export default function DishTypeSelector({ selected, onSelect }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="dish-type-selector">
      {DISH_TYPES.map((d) => {
        const Icon = d.icon;
        const isSelected = selected === d.key;
        return (
          <button
            key={d.key}
            data-testid={`dish-type-${d.key.toLowerCase().replace(/[\s/]+/g, "-")}`}
            onClick={() => onSelect(isSelected ? null : d.key)}
            className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium transition-all hover:scale-[1.03]"
            style={{
              backgroundColor: isSelected ? d.color + "22" : "#F4F1EA",
              color: isSelected ? d.color : "#5D6D7E",
              border: `2px solid ${isSelected ? d.color + "60" : "transparent"}`,
              fontFamily: "Manrope, sans-serif",
            }}
          >
            <Icon size={13} style={{ color: isSelected ? d.color : "#9AA5B1" }} strokeWidth={1.5} />
            {d.key}
          </button>
        );
      })}
    </div>
  );
}
